<style lang="scss" scoped>
.form-element {
  position: relative;
  width: 100%;
  border: 1px solid $c-dark-grey;
  margin-top: 9px;
  background: #fff;
  display: flex;

  label {
    display: block;
    border-right: 1px solid $c-dark-grey;
    background: $c-off-white;
    padding: 10px 15px;
    text-align: right;
    height: 100%;
  }

  .clickplane {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    cursor: pointer;
  }

  &.open {
    .arrow {
      opacity: 0;
    }
  }

  .arrow {
    pointer-events: none;

    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    z-index: 99;
  }

  &.twoline {
    display: block;
    label {
      border: 0;
      border-bottom: 1px solid $c-dark-grey;
    }

    .arrow {
      right: 0;
      bottom: 15px;
      top: 100%;
      transform: translateY(-130%);
      z-index: 99;
    }
  }

  .selectcontainer {
    position: relative;
    z-index: 1;
    width: 100%;
    padding: 10px 15px;
    .selected {
      cursor: pointer;
      width: 100%;
      display: inline-block;
      transition: all 0.2s;
      border-radius: 0;
      //background-color: $c-light-gray;
      // border-bottom: 2px solid $c-white;
      color: $c-dark-grey;

      outline: none;
    }

    &.open {
      z-index: 98;
      .selected {
        border-bottom: none;
      }
    }
    .dropdowncontainer {
      top: -1px;
      left: -1px;
      right: -1px;
      background: $c-white;
      border: 1px solid $c-dark-grey;

      position: absolute;
      max-height: 200px;
      overflow-y: scroll;

      .dropdownitem {
        padding: 10px 15px;
        cursor: pointer;
        transition: all 0.2s;
        &:hover {
          background-color: $c-blue;
          color: #fff;
        }
      }
    }
  }
}
</style>

<template>
  <div class="form-element" :class="{ open, twoline }">
    <label for="role" :class="{ hasvalue: model && model != '' }">{{ label }}</label>
    <div class="selectcontainer" :class="{ open }" @blur="onBlur" tabindex="0">
      <div class="clickplane" v-if="!open" @click="toggleOpen"></div>
      <div class="selected">{{ selected.label }}</div>
      <div class="dropdowncontainer" v-if="open">
        <div class="dropdownitem" :key="option.value" v-for="option in options" @click="onChange(option.value)">{{ option.label }}</div>
      </div>
    </div>
    <Icon class="arrow" :path="mdiMenuDown" :width="30" :height="30" />
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, ref, PropType } from 'vue';
import { mdiMenuDown } from '@mdi/js';

export default defineComponent({
  props: {
    options: { type: Array as PropType<Array<{ label: string; value: any }>>, required: true },
    label: { type: String, default: 'true' },
    modelValue: [String, Number],
    twoline: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const model = computed({
      get: () => props.modelValue,
      set: (id: any) => emit('update:modelValue', id),
    });
    const onChange = (value: any) => {
      model.value = value;
      open.value = false;
    };
    const selected = computed(() => props.options.find((item: any) => item.value == model.value) || { label: props.label });
    const open = ref(false);
    const toggleOpen = () => {
      open.value = !open.value;
    };
    const onBlur = () => (open.value = false);
    return {
      model,
      selected,
      onChange,
      open,
      toggleOpen,
      onBlur,
      mdiMenuDown,
    };
  },
});
</script>
